// extracted by mini-css-extract-plugin
export default {"-large":"eCs2t3JePwf3GbKPjD8r","settingPanelHeightToAuto":"aill9NzsUhFl6g37CI3R","shadowOnScroll":"UvMGbdoBJV5S5uSWlLHZ"};